import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../common/Footer";
import Navbar from "../common/Navbar";
import WhatsappChatbots from "../components/service/WhatsappChatbots";
import { Helmet } from "react-helmet";

const WhatsappChatbot = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, [location.pathname]);

  console.log("locationioio", location)

  return (
    <>
      <Helmet>
        <title>WhatsApp Chatbot Service for Business Automation</title>
        <meta
          name="description"
          content="Automate support, sales, and lead generation with our WhatsApp chatbot service. Launch AI-powered chatbots and engage customers 24×7."
        />
      </Helmet>

      <div>
        <Navbar />
        <WhatsappChatbots />
        <Footer />
      </div>
    </>
  );
};

export default WhatsappChatbot;
